/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Pie/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import CampaignOverview from './CampaignOverview/index'
import CardBase from 'DesignSystem/CardBase/index'
import PieChart from 'DesignSystem/PieChart/react'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Pie({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Pie"
  
}) {
let marketingAnalyticsValueData = fromData.useDataFormat({ viewPath,
context: 'marketing_analytics',
format: fromHelpers.pieChart,
})
  return (<React.Fragment
>
<div
  data-testid="Pie.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 marginTop={0}
 text="Campaign Overview"
/>
<CardBase
  viewPath={`${viewPath}/CardBase`}
 marginTop={16}
 alignSelf="stretch"
 backgroundColor="#fff"
 shadowColor="rgba(0, 0, 0, 0)"
>
{childProps => (
<div
  data-testid="Pie.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PieChart
  viewPath={`${viewPath}/PieChart`}
 width={200}
 height={200}
 data="marketing_analytics"
 format="helpers.js pieChart"
 value={marketingAnalyticsValueData}
/>
<CampaignOverview
  viewPath={`${viewPath}/CampaignOverview`}
/>
</div>
)}
</CardBase>
</div>
{children}
</React.Fragment>)
}